module.exports = __webpack_public_path__ + "static/img/024.b59c24f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fushen/024.png
// module id = 5Zju
// module chunks = 0